import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { ApiError } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSubmitMatterIssues = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(async () => {
    const fetchConfig = getFetchConfig({ method: FetchMethod.POST });
    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/submit-issues`, fetchConfig);
    if (!response.ok) {
      const data = await response.json().catch(() => null);
      throw new ApiError(response.status, data?.message || 'Failed to submit issues');
    }
  });
};
